import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 라우트 이동 시 스크롤 최상단 리셋.
 *  SPA 는 페이지 전환 후에도 이전 스크롤 위치가 유지돼, 목록에서 스크롤한 채 상세로 들어가면
 *  하단(예: 채용공고의 '지원한 공고예요' 버튼 근처)에서 시작하는 "자동 스크롤" 증상이 생긴다.
 *  window 와 셸 컨테이너(.container/.content-wrap) 모두 리셋(스크롤 주체가 화면마다 달라 방어적).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll(".container, .content-wrap").forEach((el) => {
      if (typeof el.scrollTo === "function") el.scrollTo(0, 0);
      else el.scrollTop = 0;
    });
  }, [pathname]);
  return null;
}
